import { getStore } from '~/mobx/AppStore';

const loadCompanyList = async () => {
    const { companyStore, userStore } = getStore();
    const isLoggedIn = userStore.getIsLoggedIn();
    const isSuperAdmin = userStore.getIsSuperAdmin();
    if (!isLoggedIn) return;

    if (isSuperAdmin) {
        await companyStore.getCompanyList();
    } else {
        await companyStore.getCompanyByUserNumber();
    }
};

export default loadCompanyList;
